// extracted by mini-css-extract-plugin
export default {"container":"QA_container__Eh4hK","answer":"QA_answer__r4C-Y","answer__container":"QA_answer__container__6JqeU","question":"QA_question__7K9Pz","plus":"QA_plus__1s83J"};